import React from "react";

import { useType } from "api/hooks";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import MoreProducts from "components/views/RecommendedProductView";
import ProductsTableView from "components/views/ProductTableView";
import Accordion from "components/views/Accordion";
import T from "i18n";

const RecommendedProductsList = () => {
  const location = useLocation();
  const { enginetypeid, gastype, catalyst } = queryString.parse(
    location.search
  );

  const { data } = useType(enginetypeid);

  const filteredData =
    data &&
    data.types.find(
      (d) => d.name === gastype && d.catalyst_fitted.toString() === catalyst
    );

  const otherProducts = filteredData && filteredData.products.slice(1);
  const moreRecosLabel = T({ path: "common.moreRecos" });
  const compareRecosLabel = T({ path: "common.compareRecos" });

  return otherProducts?.length > 0 ? (
    <Accordion
      allowMultiple
      list={[
        {
          expanded: false,
          label: moreRecosLabel,
          accordionContent: <MoreProducts list={otherProducts} className="more-products" />,
        },
        {
          expanded: true,
          label: compareRecosLabel,
          accordionContent: (
            <div style={{ marginTop: "10px" }}>
              <ProductsTableView list={filteredData.products} showLegend={false} />
            </div>
          ),
        },
      ]}
    />
  ) : null;
};

RecommendedProductsList.displayName = "RecommendedProductsList";

export default RecommendedProductsList;
